import Image from 'app/Components/Shared/Image/image';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import BulletsBlockData from 'Models/Content/BulletsBlockData';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import ProductsAndServicesItemBlockData from 'Models/Content/ProductsAndServicesItemBlockData';
import React from 'react';
import {ImageProps} from 'app/utilities/ImageProps';

type ProductAndServicesProps = {
  item: ProductsAndServicesItemBlockData;
  image: ImageProps;
};

const ProductsAndServicesItem = ({item, image}: ProductAndServicesProps) => {
  const bulletsContent = item?.bullets?.expandedValue[0] as BulletsBlockData;

  return (
    <div className='ProductsAndServicesItem'>
      {item.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
        <h3 className='ProductsAndServicesItem__title' key={i}>
          {getTextWithHighlight({text: text.value, highlightText: highlightText.value})}
        </h3>
      ))}

      <h4 className='ProductsAndServicesItem__subtitle'>{item.subtitle.value}</h4>

      <Image className='ProductsAndServicesItem__image' {...image} />

      <div className='ProductsAndServicesItem__bullets' dangerouslySetInnerHTML={{__html: bulletsContent.bullets.value}}></div>

      <a className='ProductsAndServicesItem__button' href={item.buttonLink.value}>
        {item.buttonLinkTitle.value}
      </a>
    </div>
  );
};

export default ProductsAndServicesItem;
